import * as apiCommon from '../../apiCommon';

import * as DocType from '../../../constants/constant_doc_types';
import { INVENTORY, BATCH, SERIALIZED, BUNDLE } from '../../../constants/constant_item_types';
import { setLineItemId } from '../helper_inventory';

export const getSaveInventoryAdjustmentService = ( app ) => {
  let service = app.service(`save-inventory-adjustment`);
  service.user_query = { query: app.get('user_info') };
  return service;
};

export async function saveInventoryAdjustment( app, params ) {
  const { data, user = {} } = params;

  data.lines = data.lines.map(line => {
    [
      '_id',
      'isFetchingItemLocation',
      'item',
      'next_status',
      'onEditMode',
      'reason_code',
      'status',
    ].forEach(key => delete line[key]);
    if (line.item_id) {
      line.item_id = line.item_id.split(':')[0];
    }
    return line;
  });

  ['brand_ids', 'classification_ids', 'alternate_classification_ids'].forEach(key => {
    data[key] = data[key] && data[key].length ? (
      data[key].map(item => {
        let obj = {};

        obj[key.slice(0, -1)] = item;

        return obj;
      })
    ) : null;
  });

  let inventoryAdjustment = {
    id                         : data.id,
    doc_type                   : DocType.INVENTORY_ADJUSTMENT,
    restart                    : data.restart,
    location_id                : data.location_id,
    location_type_id           : data.location_type_id,
    subsidiary_id              : data.subsidiary_id,
    currency_id                : data.currency_id,
    brands                     : data.brand_ids,
    classifications            : data.classification_ids,
    alternate_classifications  : data.alternate_classification_ids,
    status_id                  : data.status_id,
    sale_transaction_reference : data.sale_transaction_reference,
    reason_code_id             : data.reason_code_id,
    comment                    : data.comment,
    lines                      : data.lines,
    custom_fields              : data.custom_fields,
  };

  const savedInventoryAdjustment = await apiCommon.saveDoc(app, {
    source: data,
    doc: inventoryAdjustment,
    user
  });

  setLineItemId(savedInventoryAdjustment);
  return savedInventoryAdjustment;
};

export async function fetchInventoryAdjustmentById( app, params ) {
  const { id } = params;
  const result = await apiCommon.getDoc(
    app,
    { id, docType: 'inventory_adjustment' },
    { assemble_custom_fields: true }
  );
  setLineItemId(result);
  return result;
};

export const getItemLocationById = async ( app, params ) => {
  const { itemId, locationId } = params;

  if (!locationId) {
    return null;
  }

  const service = apiCommon.getAccountService(app, DocType.ITEM_LOCATION);
  const query = {
    item: itemId,
    location: locationId,
    item_types: [BATCH, BUNDLE, INVENTORY, SERIALIZED],
    // fields: [
    //   'id',
    //   'item_id',
    //   'location_id',
    //   'on_hand',
    //   'on_hand_total_cost',
    //   'back_order_quantity',
    //   'in_transit',
    //   'item_type',
    //   'average_cost'
    // ]
  }

  const { data } = await service.find({ query });

  return data[0];
};

export const getItemLocationsByIds = async ( app, params ) => {
  const { itemIds, locationId } = params;
  console.log('@getItemLocationsByIds, params', params);

  if (!locationId || itemIds.includes(undefined)) {
    return [];
  }

  const service = apiCommon.getAccountService(app, DocType.ITEM_LOCATION);
  const query = {
    item_types: [BATCH, BUNDLE, INVENTORY, SERIALIZED],
    // fields: [
    //   'id',
    //   'item_id',
    //   'location_id',
    //   'on_hand',
    //   'on_hand_total_cost',
    //   'back_order_quantity',
    //   'in_transit',
    //   'item_type',
    //   'average_cost'
    // ],
    limit: itemIds.length
  };
  const itemLocations = [];

  let itemNotAvailable = false;

  for (let i = 0; i < itemIds.length; i++) {
    const { data } = await service.find({
      query: {
        ...query,
        item: itemIds[i],
        location: locationId
      }
    });

    if (!data.length) {
      itemNotAvailable = true;
      break;
    } else {
      itemLocations.push(data[0]);
    }
  }

  return itemNotAvailable ? [] : itemLocations;
};

export const deleteInventoryAdjustment = (app, data) => {
  return apiCommon.deleteDoc(app, {
    id: data.id,
    docType: DocType.INVENTORY_ADJUSTMENT
  });
};
